<script>
import find from 'lodash/find';
import sortBy from 'lodash/sortBy';
import {mapMutations} from 'vuex';
import Heading from '@/components/Heading';
import SectionHeader from '@/components/SectionHeader';
import TrekButton from '@/components/TrekButton';
import {PdlCallout} from '@pedal/pdl-callout';

export default {
  components: {Heading, SectionHeader, TrekButton, PdlCallout},

  props: {
    accountList: {
      type: Array,
      default: () => [],
    },
    tooltipId: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      search: '',
      accountSelected: {
        accountNumber: '',
      },
    };
  },

  computed: {
    filteredList() {
      const result = this.accountList.filter((account) => this.matchesSearch(account, this.search));
      // const sort = sortBy(['name']);
      return sortBy(result, [(account) => account.name.toLowerCase(), 'accountNumber']);
    },
  },

  mounted() {
    if (this.accountList.length) {
      const activeAccount = find(this.accountList, (account) => {
        return account.active === true;
      });
      this.accountSelected = activeAccount || this.accountList[0];
      this.setB2bUnit(this.accountSelected);
      window.localStorage.setItem('currentUnitId', this.accountSelected.accountNumber);
    }
  },

  methods: {
    displayName(account) {
      return account.name;
    },

    matchesSearch({name, accountNumber}, search) {
      return name.toLowerCase().includes(search.toLowerCase()) || accountNumber.includes(search);
    },

    selectAccount(account) {
      this.accountSelected = account;
      this.setB2bUnit(account);
      this.$nextTick(() => this.$refs.form.submit());
    },

    closeTooltip() {
      let el = this.$refs[`tippy_${this.tooltipId}`];

      if (el && el._tippy) {
        el._tippy.hide();
      }
    },

    ...mapMutations('user', ['setB2bUnit']),
  },
};
</script>
